interface CompleteProductCreationNavigationOptions {
    navigateToProductHub: () => void;
    refreshProducts: () => unknown;
    selectCurrentProject?: () => Promise<unknown>;
    onSelectionError: (error: unknown) => void;
}

/**
 * Crosses the creation/navigation boundary without making Product Hub wait on
 * current-product persistence or either dashboard's product-list refresh.
 */
export function completeProductCreationNavigation({
    navigateToProductHub,
    refreshProducts,
    selectCurrentProject,
    onSelectionError
}: CompleteProductCreationNavigationOptions): void {
    navigateToProductHub();
    void refreshProducts();
    if (selectCurrentProject) {
        try {
            void selectCurrentProject().catch(onSelectionError);
        } catch (error) {
            onSelectionError(error);
        }
    }
}
